"use client"

import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../lib/commonCSSProps"
import { EmbedHtmlProps, RenderConfig } from "./RenderConfig"
export const EmbedHtml: ComponentConfig<EmbedHtmlProps> = {
  label: "Embed HTML",
  fields: {
    htmlContent: {
      label: "HTML Code",
      type: "textarea",
      description:
        "Paste raw HTML code here. Sanitization is handled server-side and on the public render layer.",
    },
    customCss: {
      label: "Custom CSS",
      type: "textarea",
      description: "Paste raw CSS code here. It will be injected inside a <style> tag.",
    },
    customJs: {
      label: "Custom JS",
      type: "textarea",
      description: "Paste raw JS code here. It will be injected inside a <script> tag.",
    },
    wrapperClassName: {
      label: "Wrapper Class",
      type: "text",
      description: "Optional CSS class for the wrapper element (e.g. 'my-custom-section')",
    },
    wrapperTag: {
      label: "Wrapper Tag",
      type: "select",
      options: [
        { label: "div", value: "div" },
        { label: "section", value: "section" },
        { label: "article", value: "article" },
        { label: "aside", value: "aside" },
        { label: "main", value: "main" },
        { label: "span", value: "span" },
      ],
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    htmlContent: `<div style="padding: 40px; text-align: center; background: #f5f5f5; border: 2px dashed #ccc; border-radius: 8px;">
  <p style="margin: 0; color: #666; font-family: sans-serif;">Paste your HTML code here</p>
</div>`,
    customCss: "",
    customJs: "",
    wrapperClassName: "",
    wrapperTag: "div",
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
}

export type { EmbedHtmlProps } from "./RenderConfig"
